// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    notMatching: {
        id: 'user.pins.not-matching',
        defaultMessage: "Oops! Your new PIN codes don't match. Check they are correct and try again."
    },
    pinChanged: {
        id: 'user.pin-changed',
        defaultMessage: 'Your PIN was successfully changed'
    }
});



// WEBPACK FOOTER //
// ./src/core/state/user/intl.js